import { client } from "@/config/client"

const deleteChallenge = ({ id }: { id: string }) => {
  return client.del(`/v1/challenges/${id}`)
}

export default deleteChallenge
